if (!customElements.get('lazy-video')) {
  customElements.define(
    'lazy-video',
    class LazyVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.shouldPlay = false;
        this.onPlaying = this.onPlaying.bind(this);
        this.onPause = this.onPause.bind(this);
        this.onGesture = this.onGesture.bind(this);
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('pause', this.onPause);
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.shouldPlay = entry.isIntersecting;
            if (this.shouldPlay) {
              this.play();
            } else if (!this.video.paused) {
              this.video.pause();
            }
          },
          { rootMargin: '100% 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.removeEventListener('playing', this.onPlaying);
        this.video?.removeEventListener('pause', this.onPause);
        this.stopWaitingForGesture();
      }

      play() {
        this.video.play().catch((error) => {
          if (error?.name === 'NotAllowedError') this.waitForGesture();
        });
      }

      waitForGesture() {
        if (this.waitingForGesture) return;
        this.waitingForGesture = true;
        document.addEventListener('touchend', this.onGesture, { passive: true, capture: true });
        document.addEventListener('click', this.onGesture, { capture: true });
      }

      stopWaitingForGesture() {
        if (!this.waitingForGesture) return;
        this.waitingForGesture = false;
        document.removeEventListener('touchend', this.onGesture, { capture: true });
        document.removeEventListener('click', this.onGesture, { capture: true });
      }

      onGesture() {
        this.stopWaitingForGesture();
        if (this.shouldPlay) this.play();
      }

      onPause() {
        if (this.shouldPlay && !document.hidden) this.play();
      }

      onPlaying() {
        this.stopWaitingForGesture();
        if (this.classList.contains('is-ready')) return;
        const reveal = () => this.classList.add('is-ready');
        if (typeof this.video.requestVideoFrameCallback === 'function') {
          this.video.requestVideoFrameCallback(reveal);
        } else {
          this.video.addEventListener('timeupdate', reveal, { once: true });
        }
      }
    }
  );
}
